var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{style:({ position: 'absolute' }),attrs:{"to":"modal","disabled":!_vm.isOpen}},[_c('div',{style:({ display: 'none' })})])}
var staticRenderFns = []

export { render, staticRenderFns }